export enum DocumentTypes {
  Pdf = 'Pdf',
  Csv = 'Csv'
}
